import { ReactElement } from "react";
import { flexidaoGrey } from "@flexidao/ui-lib";

const MAX_LABEL_LENGTH = 16;

export const CustomTick = ({
    x,
    y,
    payload,
}: {
    x: number;
    y: number;
    payload: { value: string };
}): ReactElement => {
    const fullLabel = payload.value;
    const truncated =
        fullLabel.length > MAX_LABEL_LENGTH
            ? fullLabel.slice(0, MAX_LABEL_LENGTH) + "…"
            : fullLabel;

    return (
        <g transform={`translate(${x},${y})`}>
            <title>{fullLabel}</title>

            <text x={0} y={0} dy={16} textAnchor="middle" fill={flexidaoGrey[7]} fontSize="10px">
                {truncated}
            </text>
        </g>
    );
};
